import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {VisuallyHidden} from '../../../../../libs/shared/ui/src/components/visuallyHidden/visuallyHidden';

/*
 * Props.
 */

interface ComposerSectionToggleButtonProps {
  label: ReactNode;
  isExpanded: boolean;
  onClick?: Handler;
}

/*
 * Style.
 */

// The isolated prop is whether or not we hide background on hover
const StyledToggleButtonDiv = styled(ChromelessButton)`
  display: inline-block;
  border-radius: 10px;
  padding: 0 4px;
  color: ${(p) => p.theme.greys.shade60};

  &:hover {
    color: ${(p) => p.theme.greys.shade80};
    background: ${(p) => p.theme.alphas.gray10};
  }
`;

const StyledInlineToggleButton = styled(StyledToggleButtonDiv)`
  padding: 0;
  /* Visually left-align. */
  margin: 0 0 0 -2px;

  &:hover {
    background: transparent;
  }
`;

export const ComposerSectionToggleButton: FC<ComposerSectionToggleButtonProps> = (props) => (
  <StyledToggleButtonDiv isOpen={props.isExpanded} onClick={props.onClick}>
    {renderButtonContent(props.label)}
  </StyledToggleButtonDiv>
);

export const ComposerSectionInlineToggleButton: FC<ComposerSectionToggleButtonProps> = (props) => (
  <StyledInlineToggleButton isOpen={props.isExpanded} onClick={props.onClick}>
    {renderButtonContent(props.label)}
  </StyledInlineToggleButton>
);

function renderButtonContent(label: ReactNode) {
  return (
    <>
      <Icon name="more" />
      <VisuallyHidden>{label}</VisuallyHidden>
    </>
  );
}
